function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8033 2.69669C11.3868 1.28014 9.50329 0.5 7.5 0.5C5.49671 0.5 3.61324 1.28014 2.19669 2.69669C0.780144 4.11324 0 5.99671 0 8C0 10.0033 0.780144 11.8868 2.19669 13.3033C3.61324 14.7199 5.49671 15.5 7.5 15.5C9.50329 15.5 11.3868 14.7199 12.8033 13.3033C14.2199 11.8868 15 10.0033 15 8C15 5.99671 14.2199 4.11324 12.8033 2.69669ZM7.5 14.3281C4.0107 14.3281 1.17188 11.4893 1.17188 8C1.17188 4.5107 4.0107 1.67188 7.5 1.67188C10.9893 1.67188 13.8281 4.5107 13.8281 8C13.8281 11.4893 10.9893 14.3281 7.5 14.3281ZM8.08594 7.41349H10.7227V8.58537H8.08594V11.2221H6.91406V8.58537H4.27734V7.41349H6.91406V4.77677H8.08594V7.41349Z",
  fill: "#1C9CE4"
});

var SvgPlusSm = function SvgPlusSm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlusSm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus-sm.512b196d.svg";
export { ForwardRef as ReactComponent };